/**  TODO: 
- Formatting
- Prevent infinite loop
- Add usage & total
- Groups, Options, Headers, Subtotals
- Errors/Check
- Fall back to 0/error
- Totals
- Save! (to local storage)
- Export! (to csv)
- Import (from csv)
- calculatemycost.com
- fix react updating (use imutable.js)
*/







import logo from "./logo.svg";
import "./App.css";
import { useState } from "react";

function App() {
  return (
    <div className="App">
      <header className="App-header">What's My Cost</header>
      <div>
        <Table />
      </div>
    </div>
  );
}

function Table() {
  const [rows, setRows] = useState([]);

  return (
    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Multiplier</th>
          <th>Material</th>
          <th>Size</th>
          <th>Price</th>
          <th>Cost</th>
          <th>Divisor</th>
          <th>Unit</th>
          <th>Count</th>
          <th>Qty</th>
          <th>Amount</th>
          <th>Usage</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => {
          return (
            <Row
              rows={rows}
              row={row}
              update={(key, value) => {
                row[key] = value;
                setRows(rows);
              }}
              key={i}
            />
          );
        })}
        <tr onClick={() => setRows(rows.concat(new Item()))}>
          <th colSpan="100">Add Item</th>
        </tr>
      </tbody>
    </table>
  );
}

class Item {
  getMultiplier() {
    return this.multiplier ? parseFloat(this.multiplier) : 1;
  }
  getMaterial(rows) {
    return this.material ? this.material + (this.getSize(rows)) : '';
  }
  getSize(rows) {
    if (this.size) {
      const sizeItem = rows.find(row => row.isSame(this.size));
      return sizeItem ? sizeItem.getAmount() : "error" // todo?
    }
    return ''
  }
  getPrice(rows) {
    const material = this.getMaterial(rows);
    return material ? rows.reduce((memo, row) => {
      const amount = row.isSame(material) ? row.getAmount(rows) : 0;
      return memo + amount;
    }, 0) : 1;
  }
  isSame(material) {
    return this.name == material;
  }
  getCost(rows) {
    return this.getMultiplier() * this.getPrice(rows);
  }
  getUnit(rows) {
    return this.unit ? this.unit : '';
  }
  getCount(rows) {
    const unit = this.getUnit(rows);
    return unit ? rows.reduce((memo, row) => {
      const amount = row.isSame(unit) ? row.getAmount() : 0;
      return memo + amount;
    }, 0) : 1;
  }
  getDivisor() {
    return this.divisor ? this.divisor : 1;
  }
  getQty(rows) {
    return this.getCount(rows) / this.getDivisor()
  }
  getAmount(rows) {
    return Math.ceil(this.getCost(rows) * this.getQty(rows));
  }
}

function Row({ row, rows, update }) {
  return (
    <tr>
      <th>
        <Input row={row} prop={"name"} update={update} />
      </th>
      <td><Input row={row} prop={"multiplier"} update={update} /></td>
      <td><Input row={row} prop={"material"} update={update} /></td>
      <td><Input row={row} prop={"size"} update={update} /></td>
      <td>{row.getPrice(rows)}</td>
      <td>{row.getCost(rows)}</td>
      <td><Input row={row} prop={"divisor"} update={update} /></td>
      <td><Input row={row} prop={"unit"} update={update} /></td>
      <td>{row.getCount(rows)}</td>
      <td>{row.getQty(rows)}</td>
      <td>{row.getAmount(rows)}</td>
      <td>Usage</td>
      <td>Total</td>
    </tr>
  );
}

function Input({ row, prop, update }) {
  return <input value={row[prop]} onChange={(e) => update(prop, e.target.value)} />;
}

export default App;
